import { useRouter } from 'next/router';
import styles from './ProductContent.module.scss';
import A from '../comps/A';
import B from '../comps/B';
import C from '../comps/C';
import D from '../comps/D';
import E from '../comps/E';
import F from '../comps/F';
import G from '../comps/G';
import H from '../comps/H';
import I from '../comps/I';
import J from '../comps/J';
import K from '../comps/K';
import L from '../comps/L';
import M from '../comps/M';
import N from '../comps/N';
import O from '../comps/O';
import O2 from '../comps/O2';
import P from '../comps/P';
import Q from '../comps/Q';
import R from '../comps/R';
import S from '../comps/S';
import KrO2 from '../comps/O2/kr.index';

export default function Teaser() {
    const { locale = 'us' } = useRouter();
    const IS_NA = ['us', 'ca', 'mx'].includes(locale);
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr'].includes(locale);
    return (
        <div className={`${styles['page-content']} rapid`}>
            <A />
            {locale !== 'jp' && <B />}
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            <M />
            <N />
            <O />
            {(IS_NA || IS_EU) && (locale === 'kr' ? <KrO2 /> : <O2 />)}
            <P />
            <Q />
            {IS_NA && <R />}
            <S />
        </div>
    );
}
